

import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { ChevronDown, ChevronUp } from "lucide-react";

const UserDropdown = ({ user, userData, handleSignout, toggleMobileMenu }) => {
  const [isOpen, setIsOpen] = useState(false);
  const dropdownRef = useRef(null);

  // Close dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  return (
    <div
      className="outer-box d-flex align-items-center gap-3"
      ref={dropdownRef}
    >
      {user ? (
        <div className="position-relative">
          <button
            className="btn btn-outline-secondary rounded-pill px-3 py-2 d-flex align-items-center gap-2"
            onClick={() => setIsOpen(!isOpen)}
          >
            <span className="fw-semibold">Dashboard</span>
            {isOpen ? <ChevronUp size={18} /> : <ChevronDown size={18} />}
          </button>

          {isOpen && (
            <ul
              className="dropdown-menu show mt-2 shadow-sm rounded border-0"
              style={{
                display: "block",
                position: "absolute",
                right: 0,
                minWidth: "220px",
                zIndex: 999,
              }}
            >
              <li className="dropdown-header text-muted small px-3 pt-2">
                Logged in as:
                <div className="fw-bold text-dark">
                  {userData?.userName || user.email}
                </div>
              </li>
              <li>
                <hr className="dropdown-divider" />
              </li>
              <li>
                <Link
                  to="/"
                  className="dropdown-item"
                  onClick={() => setIsOpen(false)}
                >
                  Dashboard
                </Link>
              </li>
              {userData?.userRole === "Admin" && (
                <li>
                  <Link
                    to="/"
                    className="dropdown-item"
                    onClick={() => setIsOpen(false)}
                  >
                    Admin Dashboard
                  </Link>
                </li>
              )}
              <li>
                <button className="dropdown-item" onClick={handleSignout}>
                  Logout
                </button>
              </li>
            </ul>
          )}
        </div>
      ) : (
        <ul className="main-header__login-sign-up d-flex align-items-center gap-3 mb-0 list-unstyled">
          {/* <li>
            <Link className="thm-btn feature-one__btn" to="/login">
              Login
            </Link>
          </li>
          <li>
            <Link className="thm-btn feature-one__btn" to="/register">
              Register
            </Link>
          </li> */}
        </ul>
      )}

      {/* Mobile Navigation Toggler */}
      <div className="mobile-nav-toggler" onClick={toggleMobileMenu}>
        <span className="icon-menu" />
      </div>
    </div>
  );
};

export default UserDropdown;
